var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card__container"},_vm._l((_vm.options),function(item,index){return _c('ItemCard',{key:index,attrs:{"item":item},on:{"onSelect":_vm.onSelect,"onHover":_vm.onMouseEnter}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }